<template lang="pug">
  .lightbox
    .transition-block
    .lightbox-container
      section.landing(:style="{ height : screenSize.height +'px' }")
        .box-wrapper
          WorkBox(:work="workData")
        .arrow
            img(src="~@/assets/images/down.svg")
      section.info
        .info-wrapper
          p(v-for="info in work.workDetail.info")
            br(v-if="info.length==0")
            span(v-html="info")
      //- section.photos
      //-   .photo-row(v-for="photoRow in work.workDetail.photos" :class="photoRow.length>1? 'multi-col' : 'single-col' ")
      //-     .row-container
      //-       .photo-block(v-for="(photo, i) in photoRow" :style="{ backgroundImage: 'url(' + photoRow[i] + ')' }")
      section.photos(v-if="work.workDetail.photos")
        .photo-row(v-for="photoRow in work.workDetail.photos" :class="{'multi-col':photoRow.imgs.length>1, 'fixedHeight':(photoRow.options && photoRow.options.hasOwnProperty('isFixedHeight') && photoRow.options.isFixedHeight)}")
          .row-container
            .photo-block(v-for="photo in photoRow.imgs")
              .img(v-if="photo.type === 'img'" :style="{ backgroundImage: 'url(' + photo.data + ')' }")
                img(v-if="(!photoRow.options || !photoRow.options.hasOwnProperty('isFixedHeight') || !photoRow.options.isFixedHeight)" :src="photo.data")
              video.video(v-if="photo.type === 'video'" loop autoplay muted playsinline)
                source(type="video/mp4" :src="photo.data")

      section.videos(v-if="work.workDetail.videos")
        .videos-wrapper
          YoutubePlayer(:video="video" v-for="video in work.workDetail.videos" :key="video.img")
    .close-btn(@click="back")
      img(src="~@/assets/images/close.svg", alt="")
</template>

<script>

import WorkBox from './WorkBox'
import YoutubePlayer from './YoutubePlayer'

export default {
  name: 'WorkDetail',
  components: { WorkBox, YoutubePlayer },
  props: ['work', 'screenSize'],
  data () {
    return {
      fullWidth: 0,
      fullHeight: 0
    }
  },
  computed: {
    workData: function() {
      let data = Object.assign({}, this.work);
      data.inDetail = true;
      return data;
    }
  },
  methods: {
    back() {
      if(this.work.workType == "work"){
        this.$router.push("/works");
      } else {
        this.$router.push("/experiments");
      }
    }
  },

}
</script>

<style lang="sass" scoped>
  $breakpoint: 1000px

  .lightbox
    position: fixed
    width: 100%
    height: 100%
    top: 0
    left: 0
    background-color: #fff
    z-index: 10000
    // overflow: scroll
    overflow: hidden
    .transition-block
      position: fixed
      top: 0
      left: 0
      width: 100%
      height: 100%
      // z-index: -1
      // transition: transform 1s
      z-index: 100
      background-color: #000
      transform: translateX(-100%)
    .close-btn
      position: fixed
      top: 25px
      left: 30px
      padding: 10px
      cursor: pointer
      mix-blend-mode: difference
      transition: opacity 1s
      transition-delay: 0.5s
      @media screen and (max-width: 600px)
        top: 20px
        left: 15px
      img
        width: 24px
        filter: invert(100%)

    .lightbox-container
      width: 100%
      display: flex
      flex-direction: column
      align-items: center
      transition: opacity 1s
      transition-delay: 0.5s

      height: 100%
      overflow: scroll
      overflow-x: hidden
      >*
        flex: 0 0 auto
      .landing
        width: 100%
        // height: 100vh
        display: flex
        align-items: center
        justify-content: center
        padding: 20px
        @media screen and (max-width: 600px)
          // padding: 0
        .box-wrapper
          width: 100%
          max-width: 900px
          @media screen and (max-width: 600px)
            height: 70%
        .arrow
          position: absolute
          bottom: 50px
          left: 50%
          transform: translateX(-50%)
          @media screen and (max-width: 600px)
            bottom: 30px
          img
            width: 55px
            @media screen and (max-width: 600px)
              width: 40px
      .info
        width: 100%
        padding: 70px 20px
        background-color: #000
        line-height: 1.5
        display: flex
        justify-content: center
        @media screen and (max-width: 600px)
          padding: 50px 20px
          font-size: 14px
        .info-wrapper
          width: 100%
          max-width: 900px
          p
            margin: 10px 0
      .photos
        width: 100%
        padding: 120px 20px
        max-width: 1000px
        @media screen and (max-width: 600px)
          padding: 50px 20px
        .photo-row
          width: 100%
          margin-bottom: 20px
          .row-container
            width: 100%
            display: flex
            .photo-block
              flex: 1
              width: 100%
              font-size: 0
              // box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2)
              .img
                width: 100%
                background-size: cover
                background-position: 50% 50%
                img
                  width: 100%
              .video
                width: 100%

          &.fixedHeight
            &::before
              content: ""
              display: block
              width: 100%
              padding-top: 56.25%
            .row-container
              height: 100%
              position: absolute
              top: 0
              left: 0
              .photo-block
                height: 100%
                .img
                  height: 100%
                  background-size: cover
                  background-position: 50% 50%

          &.multi-col
            .photo-block
              margin: 0 10px
              width: auto
              &:first-child
                margin-left: 0
              &:last-child
                margin-right: 0
      .videos
        width: 100%
        padding: 160px 20px
        display: flex
        justify-content: center
        background-color: #000
        @media screen and (max-width: 600px)
          padding: 50px 20px
        .videos-wrapper
          width: 100%
          max-width: 1000px
          display: flex
          flex-direction: column


  .work-detail-enter
    transform: translateX(100%)

  .work-detail-enter-active
    transition-property: opacity, transform
    transition-duration: 1s
    .lightbox-container, .close-btn
      opacity: 0

  .work-detail-leave-active
    transition-property: opacity, transform
    transition-duration: 1s
    transition-delay: 1.5s
    opacity: 0
    .transition-block
      transition: transform 1s
      transform: translateX(0%)
</style>



// WEBPACK FOOTER //
// src/components/WorkDetail.vue